/***
*
*   veriffMediaUrl
*   The path of one Veriff image of one verification.
*
*   The media route names the verification as well as the image
*   (GET /api/veriff/media/:verificationId/:id). The server lists that
*   verification's images in the caller's account and gives the image only
*   when it is in that list. Each id is encoded, so an id cannot add or change
*   a path segment. A missing id gives null: the caller skips that image.
*
*   Pure, like resend-gate.js, so it is testable without mounting a view.
*
**********/

function segment(value) {
  if (typeof value === "number") return String(value);
  if (typeof value !== "string" || value === "") return null;
  return encodeURIComponent(value);
}

export function veriffMediaUrl(verificationId, imageId) {
  const verification = segment(verificationId);
  const image = segment(imageId);
  if (!verification || !image) return null;
  return `/api/veriff/media/${verification}/${image}`;
}
